module.exports = __webpack_public_path__ + "img/Farm-anagement-System.13bfd31.png";